import React from 'react';
import clsx from 'clsx';
import { Button } from 'semantic-ui-react';
import { useIntl } from 'react-intl';
import { presentationOptions } from '@/constants/states';

const ToggleCardsButton = ({
  className,
  display = presentationOptions.CARDS,
  disabled,
  onClick,
}) => {
  const intl = useIntl();
  return (
    <div className="float-l">
      <Button
        basic
        className={clsx('aridhia--toggle-cards-button', className)}
        disabled={disabled}
        title={intl.formatMessage({
          id: display === presentationOptions.TABLE
            ? 'actions.display.cards' : 'actions.display.table',
        })}
        icon={display === presentationOptions.TABLE ? 'grid layout' : 'table'}
        circular
        onClick={disabled ? undefined : () => onClick(display === presentationOptions.TABLE
          ? presentationOptions.CARDS : presentationOptions.TABLE)}
      />
    </div>
  );
};

export default ToggleCardsButton;
